import { render } from "./ProjectsResearchPage.vue?vue&type=template&id=713c6b2d&scoped=true"
import script from "./ProjectsResearchPage.vue?vue&type=script&lang=js"
export * from "./ProjectsResearchPage.vue?vue&type=script&lang=js"

import "./ProjectsResearchPage.vue?vue&type=style&index=0&id=713c6b2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713c6b2d"]])

export default __exports__